import React from 'react'
import {CheckboxFilterForm, Row, Col} from '@modifi/ui'

import Filter, {CommonFilterProps, FilterOption} from '../../ui/filter'
import {CategoryFilterWrapper} from './styles'

export const getSelectedTaskGroupOptions = (
  categories: string[],
  options: FilterOption[]
): FilterOption[] => {
  if (!options) return []

  return options.reduce((selected: FilterOption[], option) => {
    if (option?.value?.split(',')?.every(category => categories.includes(category))) {
      selected.push(option)
    }

    if (option?.children && option.children.length > 0) {
      const selectedChildren = getSelectedTaskGroupOptions(categories, option.children)
      selected.push(...selectedChildren)
    }

    return selected
  }, [])
}

export type CategoryFilterProps = CommonFilterProps & {
  filterKey: string
  options: FilterOption[]
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  filterKey,
  options,
  ...restFilterProps
}) => {
  const getDefaultParams = (search: Record<string, any>) => ({
    defaultSelected: search[filterKey]
      ? getSelectedTaskGroupOptions(search[filterKey].sort(), options)
      : [],
  })

  const getSearchParams = (selected: FilterOption[]) => ({
    [filterKey]: selected.map(({value}) => value?.split(','))?.flat(),
  })

  return (
    <CategoryFilterWrapper>
      <Row>
        <Col>
          <Filter
            filterComponent={CheckboxFilterForm}
            options={options}
            getDefaultParams={getDefaultParams}
            getSearchParams={getSearchParams}
            {...restFilterProps}
          />
        </Col>
      </Row>
    </CategoryFilterWrapper>
  )
}

export default CategoryFilter
